import axios from "axios";
import apiUrlOne from "../Config"; // Ensure this points to your correct base URL

// Create a new banner
export const createHomeBanner = async (order, files) => {
    const formData = new FormData();
    formData.append("order", order);

    files.forEach(file => {
        formData.append("bannerImage", file);
    });

    const response = await axios.post(`${apiUrlOne}/homebanners/create-homebanners`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return response.data;
};

// Get all banners for admin
export const getAllHomeBannersAdmin = async (data) => {
    const response = await axios.get(`${apiUrlOne}/homebanners/getall-homebanners-admin`, data,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );
    return response.data;
};

// Update an existing banner
export const updateHomeBanner = async (id, order, files) => {
    const formData = new FormData();
    formData.append("order", order);

    files.forEach(file => {
        formData.append("bannerImage", file); // Optional: if files.length > 0 check can be done before calling
    });

    const response = await axios.put(`${apiUrlOne}/homebanners/update-homebanner/${id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return response.data;
};

// Delete a banner by ID
export const deleteHomeBanner = async (id) => {
    const response = await axios.delete(`${apiUrlOne}/homebanners/delete-homebanner/${id}`);
    return response.data;
};


export const getHomeBannerById = async (id) => {
    const response = await axios.get(`${apiUrlOne}/homebanners/get-homebanner/${id}`);
    return response.data;
};